import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const ShallowWaterIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Shallow water - single wave with ripples */}
    <path d="M2 14c1.5-1.5 3-1.5 4.5 0s3 1.5 4.5 0 3-1.5 4.5 0 3 1.5 4.5 0" />
    <path d="M4 18h2" />
    <path d="M10 18h4" />
    <path d="M18 18h2" />
    <circle cx="12" cy="9" r="2" />
  </svg>
);
